import { cn } from "@/src/lib/utils";

export const Link = ({ children, className, ...props }) => {
  return (
    <a
      {...props}
      className={cn(
        "rounded-lg p-2 bg-secondary border border-border flex items-center justify-center hover:bg-muted hover:border-primary/30 cursor-pointer transition-all duration-200",
        className
      )}
    >
      {children}
    </a>
  );
};
